module.exports = __webpack_public_path__ + "static/media/icon.133a18df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon.jpg
// module id = 339
// module chunks = 0